












import { defineComponent, onMounted, reactive } from '@vue/composition-api'

import Layout from '../organisms/common/Layout.vue'
import { NewsBoard, ProgressBoard, AdminBoard } from '../organisms/top'

import useVuex from '@/utils/useVuex'
import { ChainStoreState, UserState } from '@/types/store'

export default defineComponent({
  name: 'Top',
  components: { Layout, NewsBoard, ProgressBoard, AdminBoard },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      chainStores: useVuex<ChainStoreState['chainStores']>(
        context,
        () => store.getters['chainStore/chainStores'],
      ),
    })
    onMounted(() => {
      // store.dispatch('receipt/getSnapShot')
      if (state.chainStores.length === 0) {
        store.dispatch('chainStore/getChainStores', { limit: 10000 })
      }
    })

    return { state }
  },
})
